import axios from 'axios';

export const fetchBrand = async (brandId) => {
  const response = await axios.get(`/api/brands/${brandId}`);
  return response.data.brand;
};

export const fetchBrandAnalytics = async (brandId) => {
  const response = await axios.get(`/api/brands/${brandId}/analytics`);
  return response.data.analytics;
};

export const fetchBrandPlanning = async (brandId, options = {}) => {
  const params = {};
  if (options.includeHistory === false) {
    params.includeHistory = 'false';
  }
  const response = await axios.get(`/api/brands/${brandId}/planning`, { params });
  // Be flexible on response shape: some endpoints return { planning }, others return the planning object directly.
  return response.data?.planning ?? response.data;
};

export const saveBrandPlanning = async (brandId, planning) => {
  const response = await axios.post(`/api/brands/${brandId}/planning`, planning);
  return response.data.planning;
};

export const requestPlanningSuggestion = async (brandId, payload) => {
  const response = await axios.post(`/api/brands/${brandId}/planning/ai`, payload);
  return response.data;
};

export const fetchBrandList = async (params = {}) => {
  const response = await axios.get('/api/brands', { params });
  return response.data;
};

export const deleteBrand = async (brandId) => {
  const response = await axios.delete(`/api/brands/${brandId}`);
  return response.data;
};
